import React from 'react';
import { Outlet } from "react-router";

import SidebarLayout from "../SideBar/SideBar";
import styles from "./RootLayout.module.css";

const RootLayout = () => {
  return (
    <div className={styles.container}>
      <SidebarLayout />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};

export default RootLayout;